import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TokenService, User } from 'src/app/services/token.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  user: User | null = null;
  private subscription: Subscription;

  constructor(public dialog: MatDialog, private tokenService: TokenService,
    private router: Router
  ) { }

  ngOnInit() {
    this.tokenService.user$.subscribe(user => {
      this.user = user;
    });
    this.user = this.tokenService.getToken().user;
  }


  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  logout() {
    this.tokenService.clear();
    this.router.navigateByUrl("/auth/login");
  }
}
